
/* test rack */
export const PROJECT_DETAILS_TEST_RACK_ACTIVATE = 'PROJECT_DETAILS_TEST_RACK_ACTIVATE';
export const PROJECT_DETAILS_TEST_RACK_DEACTIVATE = 'PROJECT_DETAILS_TEST_RACK_DEACTIVATE';



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/project-details/actions/test-rack.ts